<template>
    <div class="lower-bar-lite lower-bar-lite-grid">
        <ResultMaterialsCard v-if="routeCheck"
                             v-show="isVisibleMaterialList"
                             :designId="designId"
                             :designMaterialChanged="designMaterialChanged"
                             id="result-materials-list"
                             class="result-card-container"/>
        <div class="lite-result-info">
            <div class="result-info-design-name-grid">
                <div class="result-info-design-name-label">
                    Дизайн:
                </div>
                <div class="result-info-design-name" v-if="designMaterialChanged > 0">
                    Пользовательский
                </div>
                <div class="result-info-design-name" v-else>
<!--                    Вариант {{$route.params.designID}}-->
                    {{selectedDesign.designName}}
                </div>
            </div>
            <div></div>
            <div class="result-info-design-name-grid clickable"
                 id="result-materials-list-switcher"
                 v-on:click="switchVisibleMaterialList()">
                <div class="result-info-design-name">
                    Список материалов
                </div>
                <div class="flex-center">
                    <SVGArrowUp class="result-info-arrow-svg" v-if="isVisibleMaterialList"/>
                    <SVGArrowDown class="result-info-arrow-svg" v-else/>
                </div>
            </div>

        </div>
        <div class="lite-result-buttons-grid">
            <div class="gl-square-btn btn-grey" v-on:click="showModal('modal-request-custom-design')">
                Применить выбранный дизайн на свой дом
            </div>
            <div></div>
            <div class="gl-square-btn btn-red" v-on:click="showModal('modal-get-price')">
                Узнать цену для своего дома
            </div>
        </div>
    </div>
</template>

<script>
    import SVGArrowDown from "../SVG/SVGArrowDown";
    import SVGArrowUp from "../SVG/SVGArrowUp";
    import ResultMaterialsCard from "./ResultMaterialsCard";
    import {modalMethods} from "../common";

    export default {
        name: "lowerBarLiteResult",
        components: {ResultMaterialsCard, SVGArrowUp, SVGArrowDown},
        mixins: [modalMethods],
        data() {
            return {
                isVisibleMaterialList: false
            }
        },
        watch: {
            designId() {
                this.$store.commit('active/DESIGN_CHANGE_COUNTER_RESET')
            }
        },
        computed: {
            routeCheck() {
                return this.$route.name !== 'liteDesignList';
            },
            designId() {
                // console.log('this.$route.params.designID', this.$route.params.designID)
                return this.$route.params.designID
            },
            designMaterialChanged() {
                return this.$store.getters["active/DESIGN_CHANGE_COUNTER"];
            },
            selectedDesign() {
                console.log('design', this.$store.getters['active/DESIGN'])
                return this.$store.getters['active/DESIGN'];
            }
        },
        methods: {
            switchVisibleMaterialList() {
                this.isVisibleMaterialList = !this.isVisibleMaterialList
            },
            defineIdInNodesRecursive(dom, deep) {
                if (dom.id) {
                    return dom.id
                } else if (deep > 4) {
                    return null
                } else {
                    return this.defineIdInNodesRecursive(dom.parentNode, deep + 1)
                }
            },
            closeOnClickOutside(event) {
                let id = this.defineIdInNodesRecursive(event.target, 0)

                if (this.isVisibleMaterialList &&
                    ![
                        'result-materials-list',
                        'result-materials-list-switcher'
                    ].includes(id)) {
                    this.isVisibleMaterialList = false
                }
            }
        },
        mounted() {
            document.addEventListener('mousedown', (event) => {this.closeOnClickOutside(event)})
        },
        beforeDestroy() {
            document.removeEventListener('mousedown', (event) => {this.closeOnClickOutside(event)})
        }
    }
</script>

<style scoped>

    .result-card-container {
        position: absolute;
        bottom: 130px;
        right: 20px;
        z-index: 1000;
    }

    .result-info-design-name-grid {
        display: grid;
        grid-template-columns: max-content max-content;
        grid-column-gap: 10px;
        height: 100%;
        width: 100%;
        align-items: center;
        padding: 0 20px;

    }

    .result-info-design-name-label {
        font-size: 14px;
    }

    .result-info-design-name {
        font-weight: bold;
        font-size: 14px;
    }

    .lite-result-info {
        height: 40px;
        /*background-color: #f6f6f6;*/
        /*background-color: #eaeaea;*/
        /*background-color: #4c4948;*/
        border-bottom: 1px solid #ededed;
        display: grid;
        grid-template-columns: max-content auto max-content;
    }

    .result-info-arrow-svg {
        margin-bottom: -4px;
    }
</style>
